var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRowView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 14v4H0v-4h6zm18 0v4H9v-4h15zM6 7v4H0V7h6zm18 0v4H9V7h15zM6 0v4H0V0h6zm18 0v4H9V0h15z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowView);
export default __webpack_public_path__ + "static/media/row-view.b618f676.svg";
export { ForwardRef as ReactComponent };